
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class FeedbackUser extends Vue {
  @Prop() text!: string;

  get _text() {

    return this.text || String(this.$t('feedbackUsercomponents.text'));
  }
}
